import { render, staticRenderFns } from "./SingleProductsList.vue?vue&type=template&id=78303000"
import script from "./SingleProductsList.js?vue&type=script&lang=js&external"
export * from "./SingleProductsList.js?vue&type=script&lang=js&external"
import style0 from "./SingleProductsList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports